module.exports = new Promise((resolve) => {
  const script = document.createElement('script');
  script.src = window.__RUNTIME_CONFIG__.STAFF_CONTENT_TILES_REMOTE_URL + '/remoteEntry.js';
  script.onload = () => {
    resolve({
      get: (request) => window.staff_web_content_tiles.get(request),
      init: (arg) => {
        try {
          return window.staff_web_content_tiles.init(arg);
        } catch(error) {
          // Do nothing.
        }
      },
    });
  }
  script.onerror = () => {
    console.log('Error loading remote app: staff_web_content_tiles');
    resolve({ get: (request) => Promise.resolve(() => ''), init: (arg) => undefined });
  }
  document.head.appendChild(script);
});
;